<template>

    <v-container grid-list-xl>

        <v-layout row wrap align-top>

            <v-flex xs12 text-xs-left class="mx-2 mb-2 py-0">

                <div class="headline grey--text text--darken-1">
                    {{ $t('labels.step4.paymentByCard') }}
                </div>

            </v-flex>

            <div v-show="chargeStatus === 0">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    <div class="subheading grey--text text--darken-3">
                        {{ $t('labels.step4.enterCreditCardDetails') }}
                    </div>

                </v-flex>

                <v-flex xs12 text-xs-left class="mx-2 mb-1">

                    <form action="/charge" method="post" id="payment-form">

                        <div id="card-element">
                            <!-- A Stripe Element will be inserted here. -->
                        </div>

                        <!-- Used to display form errors. -->
                        <div id="card-errors" role="alert"></div>
                    </form>

                </v-flex>

                <v-flex xs12 text-xs-left class="mx-0 mb-0 pb-0">

                    <v-btn class="primary" type="submit" form="payment-form">{{ $t('labels.step4.confirmOrder') }}</v-btn>

                </v-flex>

                <v-flex xs12 text-xs-left class="mx-1 ml-2 mb-0 pb-0">

                    {{ $t('labels.step4.creditCardClickConsequences') }}

                </v-flex>

            </div>

            <div v-show="chargeStatus === 2">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    <div class="cs-paymentConfirmed">
                        {{ $t('labels.step4.succesfulPayment1') }}
                    </div>

                    <div class="subheading grey--text text--darken-3">
                        {{ $t('labels.step4.succesfulPayment2') }}
                    </div>

                </v-flex>

            </div>

            <div v-show="chargeStatus === 3">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    <div class="subheading grey--text text--darken-3">
                        {{ $t('labels.step4.paymentError') }}
                    </div>

                </v-flex>

            </div>

            <div v-show="chargeStatus === 1">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    {{ $t('labels.step4.processingPayment') }} <v-progress-linear height="3" :indeterminate="true"></v-progress-linear>

                </v-flex>

            </div>

        </v-layout>

    </v-container>

</template>

<script>
import { BASE_URL } from '../../assets/constants.js';
import { STRIPE_KEY } from '../../assets/constants.js';

import firebase from 'firebase/app';
import 'firebase/database';

export default {
  name: 'stripe3-d',

  data() {
    return {
      complete: false,
      chargeStatus: 0, //O = Not initiated, 1 = Ongoing,  2 = Succeeded, 3 = Error
      chargeError: ''
    };
  },

  computed: {
    csDataContainer() {
      const step1Data = this.$store.getters.getCsStep1Data;
      const step2Data = this.$store.getters.getCsStep2Data;
      const createdAtObject = {
        createdAt: firebase.database.ServerValue.TIMESTAMP
      };
      const lng = { lng: this.$route.query.lng };
      return Object.assign(step1Data, step2Data, createdAtObject, lng);
    }
  },

  methods: {
    stripeCreateCharge(source) {
      const three_d_secure = source.card.three_d_secure;
      const stripe = Stripe(STRIPE_KEY);
      const lng = this.$route.query.lng;

      let orderId;

      firebase
        .database()
        .ref('orders')
        .push(this.csDataContainer)
        .then(snap => {
          orderId = snap.key;

          this.stripeCardChargesListener(orderId);

          if (
            three_d_secure === 'not_supported' ||
            three_d_secure === 'optional'
          ) {
            source.metadata.orderId = orderId;

            const updates = {};
            updates['/stripeCardSources/' + source.id] = { source: source };

            return firebase
              .database()
              .ref()
              .update(updates)
              .catch(error => {
                throw new Error(error.message);
              });
          } else {
            return stripe
              .createSource({
                type: 'three_d_secure',
                amount: 800,
                currency: 'eur',
                three_d_secure: {
                  card: source.id
                },
                redirect: {
                  return_url:
                    BASE_URL +
                    'step4/stripe3-dreturn?orderid=' +
                    orderId +
                    '&lng=' +
                    lng
                },
                metadata: {
                  orderId: orderId
                }
              })
              .then(result => {
                if (result.source) {
                  const updates = {};
                  updates['/stripeCardSources/' + result.source.id] = {
                    source: result.source
                  };
                  return firebase
                    .database()
                    .ref()
                    .update(updates)
                    .then(() => {
                      window.location = result.source.redirect.url;
                    });
                } else if (result.error) {
                  throw new Error(result.error.message);
                }
              })
              .catch(err => {
                throw new Error(err.message);
              });
          }
        })
        .catch(err => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error msg: ' + err.message + '(Error code: ' + err.code + ')'
          });
        });
    },

    stripeCardChargesListener(orderId) {
      firebase
        .database()
        .ref('stripeCardCharges')
        .child(orderId)
        .on('value', snapshot => {
          if (snapshot.val() !== null) {
            if (snapshot.val().status === 'succeeded') {
              this.chargeStatus = 2;
            } else if (snapshot.val().status === 'error') {
              this.chargeStatus = 3;
              this.chargeError = snapshot.val().code;
            }
          }
        });
    }
  },

  mounted: function() {
    const stripe = Stripe(STRIPE_KEY);
    const elements = stripe.elements({ locale: 'auto' });

    const classes = {
      base: 'stripe-card'
    };

    const style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: 'Roboto, Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '17px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    const card = elements.create('card', { style: style });
    card.mount('#card-element');

    card.addEventListener('change', function(event) {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    const form = document.getElementById('payment-form');
    form.addEventListener('submit', async event => {
      event.preventDefault();

      this.chargeStatus = 1;

      const { source, error } = await stripe.createSource(card);

      if (error) {
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = error.message;
      } else {
        // Send the source to your server
        this.stripeCreateCharge(source);
      }
    });
  }
};
</script>

<style scoped>
#payment-form {
  width: 440px;
  padding-bottom: 3px;
  border-bottom: 2px solid #1976d2;
}
</style>



// WEBPACK FOOTER //
// src/components/payment/Stripe3D.vue